import React from "react";
import { Alert } from "@material-ui/lab";
import { CSSTransition } from "react-transition-group";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.nodeRef = React.createRef();
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === "development") {
      console.error("ErrorBoundary caught:", error, errorInfo);
    }

    // ✅ Handle lazy-load chunk errors
    if (
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk")
    ) {
      console.warn("ChunkLoadError detected — reloading app...");
      // Wait a moment for smoother UX, then reload
      setTimeout(() => window.location.reload(true), 1000);
    }
  }

  render() {
    const { error } = this.state;
    const { children, fallback } = this.props;

    if (error) {
      return (
        fallback || (
          <CSSTransition
            in={true}
            appear
            timeout={300}
            classNames="fade"
            nodeRef={this.nodeRef}
          >
            <Alert
              ref={this.nodeRef}
              severity="error"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {/* Optional cleaner message for users */}
              {error.name === "ChunkLoadError"
                ? "A new version of the app is available. Reloading..."
                : error.stack}
            </Alert>
          </CSSTransition>
        )
      );
    }

    return children;
  }
}

export default ErrorBoundary;
